export default __webpack_public_path__ + "static/media/VD5.d89fe2fd.png";